"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const yargs = require("yargs/yargs");
const chalk = require("chalk");
const gulpSequence = require("gulp-sequence");
const urbanjs_tools_core_1 = require("urbanjs-tools-core");
const types_1 = require("./types");
const tool_service_1 = require("./tool-service");
const api_1 = require("./api");
function createBaseContainer() {
    const baseContainer = new inversify_1.Container();
    baseContainer.load(urbanjs_tools_core_1.containerModule);
    baseContainer.bind(types_1.TYPE_FACTORY_TOOL_CONTAINER).toFactory(() => createBaseContainer);
    baseContainer.bind(types_1.TYPE_DRIVER_REQUIRE).toConstantValue({ require });
    baseContainer.bind(urbanjs_tools_core_1.TYPE_DRIVER_CHALK).toConstantValue(chalk);
    baseContainer.bind(urbanjs_tools_core_1.TYPE_DRIVER_YARGS).toConstantValue(yargs);
    baseContainer.bind(urbanjs_tools_core_1.TYPE_DRIVER_GULP_SEQUENCE).toConstantValue(gulpSequence);
    baseContainer.bind(types_1.TYPE_CONFIG_TOOL_PREFIX).toConstantValue('urbanjs-tool-');
    baseContainer.bind(types_1.TYPE_TOOL_SERVICE).to(tool_service_1.ToolService).inSingletonScope();
    baseContainer.bind(types_1.TYPE_API).to(api_1.Api).inSingletonScope();
    return baseContainer;
}
exports.container = createBaseContainer();
